import { render, staticRenderFns } from "./draggableReason.vue?vue&type=template&id=6cb1a7c4&scoped=true"
import script from "./draggableReason.vue?vue&type=script&lang=js"
export * from "./draggableReason.vue?vue&type=script&lang=js"
import style0 from "./draggableReason.vue?vue&type=style&index=0&id=6cb1a7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb1a7c4",
  null
  
)

export default component.exports